import {
  Box,
  ButtonSecondary,
  selectTheme,
  styled,
  Typography,
} from '@creditas-ui/react'

export const LinkInspection = styled(Box)`
  display: flex;
  align-items: center;

  position: relative;
`

export const FeedbackInspection = styled(Box)`
  background: ${selectTheme('colors.neutral.80')};
  padding: 4px;
  border-radius: 4px;
  margin-left: 1rem;
`

export const WrapperInspectionUrl = styled.div`
  align-items: center;
  display: flex;
  padding: 4px;
  margin-top: 19px;
`

export const WrapperIcon = styled.button`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  height: 42px;
  justify-content: center;
  outline: none;
  padding: 0;
  width: 40px;
`

export const WrapperError = styled.div`
  display: flex;
  padding: 4px;
`

export const WrapperLoading = styled.div`
  margin-left: 10px;
`

export const InspectionUrl = styled(Typography)`
  color: ${({ theme }) => theme.bColorPrimary80};
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  vertical-align: middle;
`
export const FeedAction = styled(ButtonSecondary)`
  padding: 0;
  margin-top: 28px;
`
